import React from "react";
import { TooltipContentModule, TooltipContext } from "./tooltip-types";
import styles from "../table/Table.module.css";
import { theme } from "antd";
import { GroupTooltipModule } from "./GroupTooltipModule";

//A parent group is a group of groups

export const ParentGroupTooltipModule: TooltipContentModule = {
  type: "group",
  priority: 1,
  shouldRender: (context: TooltipContext) => context.type === "group",
  render: (context: TooltipContext) => {
    const { token } = theme.useToken();
    const columnKey = context.currentColumn?.measureKey;
    if (!columnKey) {
      return GroupTooltipModule.render(context);
    }

    const details = context.record?.rollupDetails?.[columnKey];
    if (!details) {
      return GroupTooltipModule.render(context);
    }

    return (
      <div className={styles.tooltipContainer}>
        {/* Group Path Section */}
        <div className={styles.section}>
          <h4 className={styles.sectionTitle}>Group</h4>
          <div className={styles.path}>
            {context.metadata.path.map((step: string, index: number) => (
              <React.Fragment key={index}>
                {index > 0 && <span className={styles.pathSeparator}>›</span>}
                <span className={styles.pathStep}>{step}</span>
              </React.Fragment>
            ))}
          </div>
        </div>

        {/* Trend Summary Section */}
        <div className={styles.section}>
          <h4 className={styles.sectionTitle}>Trend Summary</h4>
          <div className={styles.tooltipGrid}>
            {details.stats.measures.up.length > 0 && (
              <div className={styles.tooltipRow}>
                <div className={styles.tooltipLabel}>Increasing</div>
                <div
                  className={styles.tooltipValue}
                  style={{ color: token.colorSuccess }}
                >
                  {details.stats.measures.up.join(", ")}
                  <span className={styles.trendIcon}>↑</span>
                </div>
              </div>
            )}
            {details.stats.measures.down.length > 0 && (
              <div className={styles.tooltipRow}>
                <div className={styles.tooltipLabel}>Decreasing</div>
                <div
                  className={styles.tooltipValue}
                  style={{ color: token.colorError }}
                >
                  {details.stats.measures.down.join(", ")}
                  <span className={styles.trendIcon}>↓</span>
                </div>
              </div>
            )}
            {details.stats.measures.same.length > 0 && (
              <div className={styles.tooltipRow}>
                <div className={styles.tooltipLabel}>Unchanged</div>
                <div
                  className={styles.tooltipValue}
                  style={{ color: token.colorTextDescription }}
                >
                  {details.stats.measures.same.join(", ")}
                  <span className={styles.trendIcon}>→</span>
                </div>
              </div>
            )}
            {details.stats.measures.noData.length > 0 && (
              <div className={styles.tooltipRow}>
                <div className={styles.tooltipLabel}>No Data</div>
                <div
                  className={styles.tooltipValue}
                  style={{ color: token.colorTextDescription }}
                >
                  {details.stats.measures.noData.join(", ")}
                </div>
              </div>
            )}
            <div className={styles.tooltipRow}>
              <div className={styles.tooltipLabel}>Coverage</div>
              <div className={styles.tooltipValue}>{details.coverage}</div>
            </div>
          </div>
        </div>
      </div>
    );
  },
};
